import { Subscript } from "@tiptap/extension-subscript"
import { htmlMarkTokenizer, parseHtmlMark, renderHtmlMark } from "../../util/markdown-html-mark"

export const SubscriptContentExtension = Subscript.extend({
  markdownTokenName: "subscript",
  markdownTokenizer: htmlMarkTokenizer("subscript", "sub"),
  renderMarkdown: (node, helpers) => renderHtmlMark(node, helpers, "sub"),
  parseMarkdown: (token, helpers) => parseHtmlMark(token, helpers, "subscript"),
})
